if($("#kshipit").length){
  var exispincode = '';
  if(typeof(Storage) !== "undefined") {
    exispincode = sessionStorage.getItem("pincode");
  }
  $("#chkpin").val(exispincode);
  $('#pinresult').hide();
  
  var tat = 0;
  var toCurrentHourPlus = 0;
  var ziplistpre = JSON.parse(ziplistpredt);
  var ziplistcod = JSON.parse(ziplistcoddt);
  //var pinMsg = '<ul class="pincode-serviceability-list"><li><div class="pincode-tickSmallContainer"><div class="pincode-tickSmall pincode-tick sprites-lightTick"></div></div><div class="pincode-serviceabilityContainer"><p class="text-with-icons__icon-wrapper"><svg viewBox="0 0 24 22" role="presentation"><g transform="translate(1 1)" stroke-width="1.5" fill="none" fill-rule="evenodd"><path d="M5 10H2M5 15H4" stroke="#000" stroke-linecap="square"></path><path stroke="#000" d="M16.829 16H22v-6l-4-2-1-4H9v12h2.171"></path><path d="M0 5h5" stroke="#000" stroke-linecap="square"></path><path stroke="#000" stroke-linecap="square" d="M0 0h9v4"></path><circle stroke="#000" stroke-linecap="square" cx="14" cy="17" r="3"></circle><path stroke="#000" stroke-linecap="square" d="M13 7v2h2"></path></g></svg>Expected Delivery Time: 3-6 Working Days</p></div></li></ul>';
  
  $(".tickbtn").on("click", function(){  
    var selzip = ziplistpre[$("#chkpin").val()]; 
    var selzipcod = ziplistcod[$("#chkpin").val()]; 
    if (typeof(Storage) !== "undefined") {    
      sessionStorage.setItem("pincode", $("#chkpin").val());
    }        
   // console.log(sessionStorage.getItem("pincode"));
    console.log(selzip);
    
    $('.checkpinerr').html("");
    $('.pincodersltpre').html("");
   
    console.log(selzip);
    console.log(selzipcod);
    if(selzip !== undefined ){
      if(selzip == "#N/A"){
        $('.pincodersltpre').html('<span style="font-weight:600;">Sorry...!</span> Prepaid Service Not available for this pincode.');  
      }else{
       	tat = parseInt(selzip);          
        var frmdt = caldays(toCurrentHourPlus, tat);        	
        
        $('.pincodersltpre').html('<p class="text-with-icons__icon-wrapper"><svg viewBox="0 0 24 22" role="presentation"><g transform="translate(1 1)" stroke-width="1.5" fill="none" fill-rule="evenodd"><path d="M5 10H2M5 15H4" stroke="#000" stroke-linecap="square"></path><path stroke="#000" d="M16.829 16H22v-6l-4-2-1-4H9v12h2.171"></path><path d="M0 5h5" stroke="#000" stroke-linecap="square"></path><path stroke="#000" stroke-linecap="square" d="M0 0h9v4"></path><circle stroke="#000" stroke-linecap="square" cx="14" cy="17" r="3"></circle><path stroke="#000" stroke-linecap="square" d="M13 7v2h2"></path></g></svg><span>You can expect delivery between <span id="fromDate" style="font-weight:600;">'+ frmdt +'</span>');  
        //$('.pincodersltpre').html(pinMsg);
      } 
    }
    else if(selzipcod !== undefined){
      $('.pincodersltpre').html('<p class="text-with-icons__icon-wrapper"><svg viewBox="0 0 24 22" role="presentation"><g transform="translate(1 1)" stroke-width="1.5" fill="none" fill-rule="evenodd"><path d="M5 10H2M5 15H4" stroke="#000" stroke-linecap="square"></path><path stroke="#000" d="M16.829 16H22v-6l-4-2-1-4H9v12h2.171"></path><path d="M0 5h5" stroke="#000" stroke-linecap="square"></path><path stroke="#000" stroke-linecap="square" d="M0 0h9v4"></path><circle stroke="#000" stroke-linecap="square" cx="14" cy="17" r="3"></circle><path stroke="#000" stroke-linecap="square" d="M13 7v2h2"></path></g></svg>Expected Delivery Time: 1-2 Working Days</p>');      
       if(selzipcod == "Not serviceable" ){
          $('.pincodersltpre').html('<p class="text-with-icons__icon-wrapper"><svg viewBox="0 0 24 22" role="presentation"><g transform="translate(1 1)" stroke-width="1.5" fill="none" fill-rule="evenodd"><path d="M5 10H2M5 15H4" stroke="#000" stroke-linecap="square"></path><path stroke="#000" d="M16.829 16H22v-6l-4-2-1-4H9v12h2.171"></path><path d="M0 5h5" stroke="#000" stroke-linecap="square"></path><path stroke="#000" stroke-linecap="square" d="M0 0h9v4"></path><circle stroke="#000" stroke-linecap="square" cx="14" cy="17" r="3"></circle><path stroke="#000" stroke-linecap="square" d="M13 7v2h2"></path></g></svg><span>Expected Delivery Time: 1-2 Working Days.</span></p><span style="color:red;"> Sorry! Cash on Delivery is not available for this pincode!</span>');  
        }else{
         /* tat = parseInt(selzipcod);             
          var frmdtcod = caldays(toCurrentHourPlus, tat);  */       
          //$('.pincodersltcod').html('You can expect delivery between <span id="fromDate" style="font-weight:600;">'+frmdtcod+' to '+nxtdt+'</span> if you opt for Cash on Delivery.');  
          //$('.pincodersltpre').html(pinMsg);
        }     
        if(selzip == selzipcod){
          //$('.pincodersltpre').html('You can expect delivery between <span id="fromDate" style="font-weight:600;">'+frmdt+' to '+nxtdt+'</span>.');  
         // $('.pincodersltpre').html(pinMsg);  
          $('.pincodersltpre').html('');  
        }        
      }  
    else{
      $('.pincodersltpre').html('<span style="color:red;">Please enter valid pincode!</span>');
    }
    $('#pinresult').show();
  }); 


  $(window).on('load', function() {  	
    if(exispincode != null)
    {
      var selzip = ziplistpre[exispincode]; 
      var selzipcod = ziplistcod[exispincode];        
      $('.checkpinerr').html("");
	  $('.pincodersltpre').html("");
      
      
      if(selzip !== undefined ){
      if(selzip == "#N/A"){
        $('.pincodersltpre').html('<span style="color:red;"><span style="font-weight:600;">Sorry...!</span> Prepaid Service Not available for this pincode.</span>');
      }else{
        tat = parseInt(selzip);          
        var frmdt = caldays(toCurrentHourPlus, tat);                
        $('.pincodersltpre').html('<p class="text-with-icons__icon-wrapper"><svg viewBox="0 0 24 22" role="presentation"><g transform="translate(1 1)" stroke-width="1.5" fill="none" fill-rule="evenodd"><path d="M5 10H2M5 15H4" stroke="#000" stroke-linecap="square"></path><path stroke="#000" d="M16.829 16H22v-6l-4-2-1-4H9v12h2.171"></path><path d="M0 5h5" stroke="#000" stroke-linecap="square"></path><path stroke="#000" stroke-linecap="square" d="M0 0h9v4"></path><circle stroke="#000" stroke-linecap="square" cx="14" cy="17" r="3"></circle><path stroke="#000" stroke-linecap="square" d="M13 7v2h2"></path></g></svg><span>Your delivery will be received between <span id="fromDate" style="font-weight:600;">'+ frmdt +'</span>');  
        //$('.pincodersltpre').html(pinMsg);
      } 
    }
    else if(selzipcod !== undefined){
       $('.pincodersltpre').html('<p class="text-with-icons__icon-wrapper"><svg viewBox="0 0 24 22" role="presentation"><g transform="translate(1 1)" stroke-width="1.5" fill="none" fill-rule="evenodd"><path d="M5 10H2M5 15H4" stroke="#000" stroke-linecap="square"></path><path stroke="#000" d="M16.829 16H22v-6l-4-2-1-4H9v12h2.171"></path><path d="M0 5h5" stroke="#000" stroke-linecap="square"></path><path stroke="#000" stroke-linecap="square" d="M0 0h9v4"></path><circle stroke="#000" stroke-linecap="square" cx="14" cy="17" r="3"></circle><path stroke="#000" stroke-linecap="square" d="M13 7v2h2"></path></g></svg>Expected Delivery Time: 3-6 Working Days</p>'); 
      
       if(selzipcod == "Not serviceable" ){
          $('.pincodersltpre').html('<span style="color:red;">Sorry! Cash on Delivery is not available for this pincode!</span>');  
        }else{
          /*tat = parseInt(selzipcod);             
          var frmdtcod = caldays(toCurrentHourPlus, tat);  */       
          //$('.pincodersltcod').html('You can expect delivery between <span id="fromDate" style="font-weight:600;">'+frmdtcod+' to '+nxtdt+'</span> if you opt for Cash on Delivery.');  
          //$('.pincodersltpre').html(pinMsg);
        }     
        if(selzip == selzipcod){
          //$('.pincodersltpre').html('You can expect delivery between <span id="fromDate" style="font-weight:600;">'+frmdt+' to '+nxtdt+'</span>.');  
          //$('.pincodersltpre').html(pinMsg);  
          $('.pincodersltpre').html('');  
        }        
      }  
    else{
      $('.pincodersltpre').html('<span style="color:red;">Please enter valid pincode!</span>');
    }
    $('#pinresult').show();
    }

  });
  
    function caldays(toCurrentHourPlus, tatdays){      
      if(tatdays == '24'){   	 
        tatdays = 0;
      }
      else if(tatdays == '48'){
   	 	tatdays = 0;  
      } 
      else if(tatdays == '72'){
   	 	tatdays = 0;  
      } 
      else if(tatdays == '96'){
   	 	tatdays = 0;  
      } else if(tatdays ==  '120'){
   	 	tatdays = 0;   
      }
    
    var toCurrentDate = new Date();
    var toCurrentHour = toCurrentDate.getHours();      
      
    if(toCurrentHour >= 14){ toCurrentHourPlus=toCurrentHourPlus+1; }       
    if (tatdays > 0){
      toCurrentHourPlus = toCurrentHourPlus + tatdays;
    }        
    var fromDate = Date.today().addDays(toCurrentHourPlus);    
    
    if (fromDate.is().sunday()) { 
      fromDate = fromDate.next().monday();
    }        
    var seldt = fromDate.toString('ddd, MMM dS');     
    var toDate = fromDate.addDays(1);
    var selltoDate = toDate.toString('ddd, MMM dS');     
      
      
    var finalDates = seldt + " to " + selltoDate;
    return finalDates;
  }
     
  }